/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  cpu_benchmarks: Yup.object().shape({
    enabled: Yup.boolean(),
    execution_interval_minutes: Yup.number().when('enabled', {
      is: true,
      then: Yup.number()
        .required(i18n.t('REQUIRED_FIELD_KEY'))
        .min(
          30,
          i18n.t('MIN_VALUE_KEY', {
            value: 30,
          })
        )
        .max(
          1440,
          i18n.t('MAX_VALUE_KEY', {
            value: 1440,
          })
        )
        .nullable(true),
      otherwise: Yup.number()
        .min(
          30,
          i18n.t('MIN_VALUE_KEY', {
            value: 30,
          })
        )
        .max(
          1440,
          i18n.t('MAX_VALUE_KEY', {
            value: 1440,
          })
        )
        .nullable(true),
    }),
    duration_seconds: Yup.number().when('enabled', {
      is: true,
      then: Yup.number()
        .required(i18n.t('REQUIRED_FIELD_KEY'))
        .min(
          10,
          i18n.t('MIN_VALUE_KEY', {
            value: 10,
          })
        )
        .max(
          60,
          i18n.t('MAX_VALUE_KEY', {
            value: 60,
          })
        )
        .nullable(true),
      otherwise: Yup.number()
        .min(
          10,
          i18n.t('MIN_VALUE_KEY', {
            value: 10,
          })
        )
        .max(
          60,
          i18n.t('MAX_VALUE_KEY', {
            value: 60,
          })
        )
        .nullable(true),
    }),
  }),
});
